import { Component, Prop } from "vue-property-decorator";
import Vue from "vue";

import UnitConstants from "../../common/unit-constant";
import {DEFAULT_NUMBER_DECIMAL} from "../../common/constants";
import { LabelSetting } from '../../i18n/locale-helper';

@Component({
  template: require("./template.html")
})
export default class InputNumberFormattedComponent extends Vue {
  UnitConstants = UnitConstants;

  @Prop({ default: () => 0 })
  value: number;

  @Prop({ type: [Number], default: () => 0 })
  unit;

  @Prop({ type: [String], default: 'decimal' })
  type;

  @Prop({ type: [Number], default: () => 2 })
  fractionDigits;

  @Prop({ type: Boolean, default: false })
  enableFractionDigit;

  get formatValue() {
    var result =  Intl.NumberFormat(this.$i18n.locale, {
        maximumFractionDigits: (this.type === 'decimal') ? DEFAULT_NUMBER_DECIMAL.maximumFractionDigits : DEFAULT_NUMBER_DECIMAL.minimumFractionDigits
    }).format(this.value);

    if(this.enableFractionDigit)
    {
      result  = Intl.NumberFormat(this.$i18n.locale, {
        minimumFractionDigits: 0, maximumFractionDigits: 2
      }).format(this.value);
    }

    switch(this.unit)
    {
       case UnitConstants.SQUARE_METRE:
          result += " m<sup>2</sup>";
          break;
        case UnitConstants.METRE:
          result += " m";
        break;
        case UnitConstants.CUBIC_METRE:
          result += " m<sup>3</sup>";
        break;
        case UnitConstants.LITRE:
          result += " l";
          break;
        case UnitConstants.CURRENCY:
          result += " €";
        break;
        case UnitConstants.PERCENT:
          result += " %";
        break;
        case UnitConstants.PICOLITER:
          result += " pl";
          break;
        case UnitConstants.ENERGY:
          result += " kWh/m<sup>2</sup>/" + this.$t(LabelSetting.Global.year).toString();
        break;
        case UnitConstants.KILOGRAM:
          result += " kg";
        break;
        case UnitConstants.SQUARE_METRE_PER_YEAR:
          result += " m<sup>2</sup>/" + this.$t(LabelSetting.Global.year).toString();
        break;
        case UnitConstants.EPC_TOTAL:
          result += " kWh/" + this.$t(LabelSetting.Global.year).toString();
        break;
    }

    return result;
  }

  beforeDestroy(){
    this.UnitConstants = null;
  }
}
